import { type ModuleConfig } from '/@/cool';

export default (): ModuleConfig => {
	return {
		index: {
			component: import('./components/index.vue')
		}
	};
};
